import { takeLatest, takeEvery, put, select, takeLeading } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys } from './helper'
import { httpGet } from '../core/restClient'
// import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import r from 'reactotron-react-js'

const GET_ACCOUNT_ASSIGNMENTS = makeKeys('GET_ACCOUNT_ASSIGNMENTS')
const GET_ASSETS = makeKeys('GET_ASSETS')
const GET_BANK_BRANCH = makeKeys('GET_BANK_BRANCH')
const GET_BANK_KEYS = makeKeys('GET_BANK_KEYS')
const GET_BUDGET_TYPES = makeKeys('GET_BUDGET_TYPES')
const GET_BUSINESS_PARTNERS = makeKeys('GET_BUSINESS_PARTNER_LIST')
const GET_BP_GROUPS = makeKeys('GET_BP_GROUPS')
const GET_COMPANIES = makeKeys('GET_COMPANIES')
const GET_COST_CENTER = makeKeys('GET_COST_CENTER')
const GET_COUNTRY = makeKeys('GET_COUNTRY')
const GET_CURRENCIES = makeKeys('GET_CURRENCIES')
const GET_CUSTOMERS = makeKeys('GET_CUSTOMERS')
const GET_GL_ACCOUNTS = makeKeys('GET_GL_ACCOUNTS')
const GET_INCOTERMS = makeKeys('GET_INCOTERMS')
const GET_INDUSTRIES = makeKeys('GET_INDUSTRIES')
const GET_MATERIAL_GROUPS = makeKeys('GET_MATERIAL_GROUPS')
const GET_MATERIALS = makeKeys('GET_MATERIALS')
const GET_ORDERS = makeKeys('GET_ORDERS')
const GET_PAYEES = makeKeys('GET_PAYEES')
const GET_PAYMENT_BLOCK = makeKeys('GET_PAYMENT_BLOCK')
const GET_PAYMENT_METHOD = makeKeys('GET_PAYMENT_METHOD')
const GET_PAYMENT_TERM = makeKeys('GET_PAYMENT_TERM')
const GET_PLANTS = makeKeys('GET_PLANTS')
const GET_PLANNING_GROUPS = makeKeys('GET_PLANNING_GROUPS')
const GET_PR_CATEGORIES = makeKeys('GET_PR_CATEGORIES')
const GET_PR_TYPES = makeKeys('GET_PR_TYPES')
const GET_PROFIT_CENTERS = makeKeys('GET_PROFIT_CENTERS')
const GET_PURCHASING_GROUPS = makeKeys('GET_PURCHASING_GROUPS')
const GET_PURCHASING_ORGS = makeKeys('GET_PURCHASING_ORGS')
const GET_RECONCILIATIONS = makeKeys('GET_RECONCILIATIONS')
const GET_STORAGE_LOCATIONS = makeKeys('GET_STORAGE_LOCATIONS')
const GET_SORT_KEYS = makeKeys('GET_SORT_KEYS')
const GET_TRADING_PARTNERS = makeKeys('GET_TRADING_PARTNERS')
const GET_UNITS = makeKeys('GET_UNITS')
const GET_VENDORS = makeKeys('GET_VENDORS')
const GET_WBS_ELEMENTS = makeKeys('GET_WBS_ELEMENTS')
const GET_WHT_TYPES = makeKeys('GET_WHT_TYPES')
const GET_WHT_RECEIPT_TYPES = makeKeys('GET_WHT_RECEIPT_TYPES')
const FETCH_PROJECTS = makeKeys('FETCH_PROJECTS')
const FETCH_PM_USERS = makeKeys('FETCH_PM_USERS')
const FETCH_ROLE_PURCHASE_OFFICER = makeKeys('FETCH_ROLE_PURCHASE_OFFICER')
const FETCH_PO_ACTIVE_VENDOR = makeKeys('FETCH_PO_ACTIVE_VENDOR')
const FETCH_CONTRACT_ACTIVE_VENDOR = makeKeys('FETCH_CONTRACT_ACTIVE_VENDOR')
const FETCH_PRODUCT_BRANDS_OPTIONS = makeKeys('FETCH_PRODUCT_BRANDS_OPTIONS')
const GET_TYPE_OF_TENDERS = makeKeys('GET_TYPE_OF_TENDERS')
const GET_WORKS = makeKeys('GET_WORKS')
const FETCH_STATS_PO_WORKSPACE = makeKeys('FETCH_STATS_PO_WORKSPACE')
const GET_STAMP_DUTY_OPTIONS = makeKeys('GET_STAMP_DUTY_OPTIONS')
const GET_PR_SPECIAL_OPTIONS = makeKeys('GET_PR_SPECIAL_OPTIONS')
const GET_PO_NUMBER = makeKeys('GET_PO_NUMBER')
const GET_LIST_PO_COMPLETE_NUMBER = makeKeys('GET_LIST_PO_COMPLETE_NUMBER')

export const getAccountAssignments = makeAction(GET_ACCOUNT_ASSIGNMENTS.REQUEST)
export const getAssets = makeAction(GET_ASSETS.REQUEST)
export const getBankBranch = makeAction(GET_BANK_BRANCH.REQUEST, 'bankKey')
export const getBankKeys = makeAction(GET_BANK_KEYS.REQUEST)
export const getBudgetTypes = makeAction(GET_BUDGET_TYPES.REQUEST)
export const getBusinessPartners = makeAction(GET_BUSINESS_PARTNERS.REQUEST)
export const getBPGroups =  makeAction(GET_BP_GROUPS.REQUEST)
export const getCompanies = makeAction(GET_COMPANIES.REQUEST)
export const getPayees = makeAction(GET_PAYEES.REQUEST)
export const getCostCenter = makeAction(GET_COST_CENTER.REQUEST, 'data')
export const getCountry = makeAction(GET_COUNTRY.REQUEST)
export const getCurrencies = makeAction(GET_CURRENCIES.REQUEST)
export const getCustomers = makeAction(GET_CUSTOMERS.REQUEST)
export const getGlAccounts = makeAction(GET_GL_ACCOUNTS.REQUEST)
export const getIncoterms = makeAction(GET_INCOTERMS.REQUEST)
export const getIndustries = makeAction(GET_INDUSTRIES.REQUEST)
export const getMaterials = makeAction(GET_MATERIALS.REQUEST, 'plant')
export const getMaterialGroups = makeAction(GET_MATERIAL_GROUPS.REQUEST)
export const getOrders = makeAction(GET_ORDERS.REQUEST)
export const getPaymentBlocks = makeAction(GET_PAYMENT_BLOCK.REQUEST)
export const getPaymentMethods = makeAction(GET_PAYMENT_METHOD.REQUEST)
export const getPaymentTerms = makeAction(GET_PAYMENT_TERM.REQUEST)
export const getPlants = makeAction(GET_PLANTS.REQUEST)
export const getPlanningGroups = makeAction(GET_PLANNING_GROUPS.REQUEST)
export const getPrCategories = makeAction(GET_PR_CATEGORIES.REQUEST)
export const getProfitCenters = makeAction(GET_PROFIT_CENTERS.REQUEST)
export const getPrTypes = makeAction(GET_PR_TYPES.REQUEST)
export const getPurchasingGroups = makeAction(GET_PURCHASING_GROUPS.REQUEST)
export const getPurchasingOrgs = makeAction(GET_PURCHASING_ORGS.REQUEST)
export const getReconciliations = makeAction(GET_RECONCILIATIONS.REQUEST, 'companyCode')
export const getSortKeys = makeAction(GET_SORT_KEYS.REQUEST)
export const getStorageLocations = makeAction(GET_STORAGE_LOCATIONS.REQUEST)
export const getTradingPartners = makeAction(GET_TRADING_PARTNERS.REQUEST)
export const getUnits = makeAction(GET_UNITS.REQUEST)
export const getVendors = makeAction(GET_VENDORS.REQUEST)
export const getWbsElements = makeAction(GET_WBS_ELEMENTS.REQUEST, 'companyCode')
export const getWhtTypes = makeAction(GET_WHT_TYPES.REQUEST)
export const getWhtReceiptTypes = makeAction(GET_WHT_RECEIPT_TYPES.REQUEST)
export const fetchProjects = makeAction(FETCH_PROJECTS.REQUEST, 'companyCode')
export const fetchPMUsers = makeAction(FETCH_PM_USERS.REQUEST)
export const fetchRolePurchaseOfficer = makeAction(FETCH_ROLE_PURCHASE_OFFICER.REQUEST, 'purchGroup')
export const fetchPOActiveVendors = makeAction(FETCH_PO_ACTIVE_VENDOR.REQUEST)
export const fetchContractActiveVendors = makeAction(FETCH_CONTRACT_ACTIVE_VENDOR.REQUEST)
export const fetchProductBrandsOptions = makeAction(FETCH_PRODUCT_BRANDS_OPTIONS.REQUEST)
export const getTypeOfTenders = makeAction(GET_TYPE_OF_TENDERS.REQUEST)
export const getWorks = makeAction(GET_WORKS.REQUEST)
export const fetchStatusPOWorkSpace = makeAction(FETCH_STATS_PO_WORKSPACE.REQUEST)
export const getStampDutyOptions = makeAction(GET_STAMP_DUTY_OPTIONS.REQUEST)
export const getPrSpecialOptions = makeAction(GET_PR_SPECIAL_OPTIONS.REQUEST, 'type')
export const getPoNumber = makeAction(GET_PO_NUMBER.REQUEST, 'companyCode', 'onLoadSuccess')
export const getListPoCompleteNumber = makeAction(GET_LIST_PO_COMPLETE_NUMBER.REQUEST)

const getAccountAssignmentsSuccess = makeAction(GET_ACCOUNT_ASSIGNMENTS.SUCCESS, 'data')
const getAssetsSuccess = makeAction(GET_ASSETS.SUCCESS, 'data')
const getBankBranchSuccess = makeAction(GET_BANK_BRANCH.SUCCESS, 'data', 'bankKey')
const getBankKeysSuccess = makeAction(GET_BANK_KEYS.SUCCESS, 'data')
const getBudgetTypesSuccess = makeAction(GET_BUDGET_TYPES.SUCCESS, 'data')
const getBusinessPartnersSuccess = makeAction(GET_BUSINESS_PARTNERS.SUCCESS, 'data')
const getBPGroupsSuccess = makeAction(GET_BP_GROUPS.SUCCESS, 'data')
const getCompaniesSuccess = makeAction(GET_COMPANIES.SUCCESS, 'data')
const getCostCenterSuccess = makeAction(GET_COST_CENTER.SUCCESS, 'data')
const getCountrySuccess = makeAction(GET_COUNTRY.SUCCESS, 'data')
const getCurrenciesSuccess = makeAction(GET_CURRENCIES.SUCCESS, 'data')
const getCustomersSuccess = makeAction(GET_CUSTOMERS.SUCCESS, 'data')
const getGlAccountsSuccess = makeAction(GET_GL_ACCOUNTS.SUCCESS, 'data')
const getIncotermsSuccess = makeAction(GET_INCOTERMS.SUCCESS, 'data')
const getIndustriesSuccess = makeAction(GET_INDUSTRIES.SUCCESS, 'data')
const getMaterialsSuccess = makeAction(GET_MATERIALS.SUCCESS, 'data', 'plant')
const getMaterialGroupsSuccess = makeAction(GET_MATERIAL_GROUPS.SUCCESS, 'data')
const getOrdersSuccess = makeAction(GET_ORDERS.SUCCESS, 'data')
const getPaymentBlockSuccess = makeAction(GET_PAYMENT_BLOCK.SUCCESS, 'data')
const getPaymentMethodSuccess = makeAction(GET_PAYMENT_METHOD.SUCCESS, 'data')
const getPaymentTermSuccess = makeAction(GET_PAYMENT_TERM.SUCCESS, 'data')
const getPlantsSuccess = makeAction(GET_PLANTS.SUCCESS, 'data')
const getPlanningGroupsSuccess = makeAction(GET_PLANNING_GROUPS.SUCCESS, 'data')
const getPrCategoriesSuccess = makeAction(GET_PR_CATEGORIES.SUCCESS, 'data')
const getProfitCentersSuccess = makeAction(GET_PROFIT_CENTERS.SUCCESS, 'data')
const getPrTypesSuccess = makeAction(GET_PR_TYPES.SUCCESS, 'data')
const getPurchasingGroupsSuccess = makeAction(GET_PURCHASING_GROUPS.SUCCESS, 'data')
const getPurchasingOrgsSuccess = makeAction(GET_PURCHASING_ORGS.SUCCESS, 'data')
const getReconciliationsSuccess = makeAction(GET_RECONCILIATIONS.SUCCESS, 'data', 'companyCode')
const getSortKeysSuccess = makeAction(GET_SORT_KEYS.SUCCESS, 'data')
const getStorageLocationsSuccess = makeAction(GET_STORAGE_LOCATIONS.SUCCESS, 'data')
const getTradingPartnersSuccess = makeAction(GET_TRADING_PARTNERS.SUCCESS, 'data')
const getUnitsSuccess = makeAction(GET_UNITS.SUCCESS, 'data')
const getVendorsSuccess = makeAction(GET_VENDORS.SUCCESS, 'data')
const getWbsElementsSuccess = makeAction(GET_WBS_ELEMENTS.SUCCESS, 'data')
const getWhtTypesSuccess = makeAction(GET_WHT_TYPES.SUCCESS, 'data')
const getWhtReceiptTypesSuccess = makeAction(GET_WHT_RECEIPT_TYPES.SUCCESS, 'data')
const fetchProjectsSuccess = makeAction(FETCH_PROJECTS.SUCCESS, 'data')
const fetchPMUsersSuccess = makeAction(FETCH_PM_USERS.SUCCESS, 'data')
const fetchRolePurchaseOfficerSuccess = makeAction(FETCH_ROLE_PURCHASE_OFFICER.SUCCESS, 'data')
const fetchPOActiveVendorsSuccess = makeAction(FETCH_PO_ACTIVE_VENDOR.SUCCESS, 'data')
const fetchContractActiveVendorsSuccess = makeAction(FETCH_CONTRACT_ACTIVE_VENDOR.SUCCESS, 'data')
const fetchProductBrandsOptionsSuccess = makeAction(FETCH_PRODUCT_BRANDS_OPTIONS.SUCCESS, 'data')
const getTypeOfTendersSuccess = makeAction(GET_TYPE_OF_TENDERS.SUCCESS, 'data')
const getWorksSuccess = makeAction(GET_WORKS.SUCCESS, 'data')
const fetchStatusPOWorkSpaceSuccess = makeAction(FETCH_STATS_PO_WORKSPACE.SUCCESS, 'data')
const getStampDutyOptionsSuccess = makeAction(GET_STAMP_DUTY_OPTIONS.SUCCESS, 'data')
const getPrSpecialOptionsSuccess = makeAction(GET_PR_SPECIAL_OPTIONS.SUCCESS, 'data')
const getPoNumberSuccess = makeAction(GET_PO_NUMBER.SUCCESS, 'data', 'companyCode')
const getListPoCompleteNumberSuccess = makeAction(GET_LIST_PO_COMPLETE_NUMBER.SUCCESS, 'data')

const initial = {
  accountAssignments: { data: [], loading: false },
  assets: { data: [], loading: false },
  bankBranch: { data: {}, loading: false },
  bankKeys: { data: [], loading: false },
  budgetTypes: { data: [], loading: false },
  businessPartners: { data: [], loading: false },
  businessPartnerGroups: { data: [], loading: false },
  companies: { data: [], loading: false, timeStamp: 0 },
  costCenters: { data: [], loading: false },
  countries: { data: [], loading: false },
  currencies: { data: [], loading: false },
  customers: { data: [], loading: false },
  glAccounts: { data: [], loading: false },
  incoterms: { data: [], loading: false },
  industries: { data: [], loading: false },
  materials: { data: {}, loading: false },
  materialGroups: { data: [], loading: false },
  orders: { data: [], loading: false },
  paymentBlocks: { data: [], loading: false },
  paymentMethods: { data: [], loading: false },
  paymentTerms: { data: [], loading: false },
  plants: { data: [], loading: false },
  planningGroups: { data: [], loading: false },
  prCategories: { data: [], loading: false },
  projects: { data: [], loading: false },
  prTypes: { data: [], loading: false },
  profitCenters: { data: [], loading: false },
  purchasingGroups: { data: [], loading: false },
  purchasingOrgs: { data: [], loading: false },
  reconciliations: { data: [], companyCode: '', loading: false },
  sortKeys: { data: [], loading: false },
  storageLocations: { data: [], loading: false },
  tradingPartners: { data: [], loading: false },
  units: { data: [], loading: false },
  vendors: { data: [], loading: false, timeStamp: 0 },
  wbsElements: { data: [], loading: false },
  whtTypes: { data: [], loading: false },
  whtReceiptTypes: { data: [], loading: false },
  pmUsers: { data: [], loading: false },
  purchaseOfficer: { data: [], loading: false },
  poVendors: { data: [], loading: false },
  contractVendors: { data: [], loading: false },
  productBrands: { data: [], loading: false },
  typeOfTenders: { data: [], loading: false },
  works: { data: [], loading: false },
  statusPOWorkSpace: { data: [], loading: false },
  stampDuty: { data: [], loading: false },
  prSpecial: { data: [], loading: false },
  poNumbers: { data: [], loading: false, companyCode: '' },
  optionPoComplete: { data: [], loading: false }
}

function* getAccountAssignmentsRequest(action) {
  try {
    const response = yield httpGet('options/accountAssignments')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAccountAssignmentsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getAccountAssignmentsSuccess([]))
  }
}

function* getAssetsRequest(action) {
  try {
    const response = yield httpGet('options/assets')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getAssetsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getAssetsSuccess([]))
  }
}

function* getBankBranchRequest(action) {
  const { bankKey } = action.payload
  try {
    const response = yield httpGet(`options/bankBranchs/${bankKey}`)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBankBranchSuccess(response.data, bankKey))
      }
    }
  } catch (e) {
    yield put(getBankKeysSuccess([]))
  }
}

function* getBankKeysRequest(action) {
  try {
    const response = yield httpGet('options/bankKeys')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBankKeysSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getBankKeysSuccess([]))
  }
}

function* getBudgetTypesRequest(action) {
  try {
    const response = yield httpGet('options/budgetTypes')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBudgetTypesSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getBudgetTypesSuccess([]))
  }
}

function* getBusinessPartnersRequest(action) {
  try {
    const response = yield httpGet('options/businessPartner')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBusinessPartnersSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getBusinessPartnersSuccess([]))
  }
}

function* getBPGroupsRequest(action) {
  try {
    const response = yield httpGet('options/businessPartnerGroups')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBPGroupsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getBPGroupsSuccess([]))
  }
}

function* getCompaniesRequest(action) {
  try {
    const state = yield select()
    if (!state.options.companies.data.length&&state.options.companies.timeStamp==1) {
      const response = yield httpGet('options/companies')
      if (response.status >= 200 && response.status < 300) {
        if (response.data) {
          yield put(getCompaniesSuccess(response.data))
        }
      }
    }
  } catch (e) {
    yield put(getCompaniesSuccess([]))
  }
}

// function* getPayeesRequest(action) {
//   try {
//     const response = yield httpGet('options/Payees')
//     if (response.status >= 200 && response.status < 300) {
//       if (response.data) {
//         yield put(getPayeesSuccess(response.data))
//       }
//     }
//   } catch (e) {
//     yield put(getPayeesSuccess([]))
//   }
// }

function* getCostCenterRequest(action) {
  const { data } = action.payload
  try {
    const response = yield httpGet('options/costCenters', data)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getCostCenterSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getCostCenterSuccess([]))
  }
}

function* getCountryRequest(action) {
  try {
    const response = yield httpGet('options/countries')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getCountrySuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getCountrySuccess([]))
  }
}

function* getCurrenciesRequest(action) {
  try {
    const response = yield httpGet('options/currencies')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getCurrenciesSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getCurrenciesSuccess([]))
  }
}

function* getCustomersRequest(action) {
  try {
    const response = yield httpGet('options/customers')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getCustomersSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getCustomersSuccess([]))
  }
}

function* getIncotermsRequest(action) {
  try {
    const response = yield httpGet('options/incoterms')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getIncotermsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getIncotermsSuccess([]))
  }
}

function* getIndustriesRequest(action) {
  try {
    const response = yield httpGet('options/industries')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getIndustriesSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getIndustriesSuccess([]))
  }
}

function* getGlAccountsRequest(action) {
  try {
    const response = yield httpGet('options/glAccounts')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getGlAccountsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getGlAccountsSuccess([]))
  }
}

function* getMaterialsRequest(action) {
  const { plant } = action.payload
  try {
    const response = yield httpGet('options/materials', { plant })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMaterialsSuccess(response.data, plant))
      }
    }
  } catch (e) {
    yield put(getMaterialGroupsSuccess([]))
  }
}

function* getMaterialGroupsRequest(action) {
  try {
    const response = yield httpGet('options/materialGroups')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getMaterialGroupsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getMaterialGroupsSuccess([]))
  }
}

function* getOrdersRequest(action) {
  try {
    const response = yield httpGet('options/orders')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getOrdersSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getOrdersSuccess([]))
  }
}

function* getPaymentBlocksRequest(action) {
  try {
    const response = yield httpGet('options/paymentBlocks')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPaymentBlockSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPaymentBlockSuccess([]))
  }
}

function* getPaymentMethodsRequest(action) {
  try {
    const response = yield httpGet('options/paymentMethods')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPaymentMethodSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPaymentMethodSuccess([]))
  }
}

function* getPaymentTermsRequest(action) {
  try {
    const response = yield httpGet('options/paymentTerms')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPaymentTermSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPaymentTermSuccess([]))
  }
}

function* getPlantsRequest(action) {
  try {
    const response = yield httpGet('options/plants')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPlantsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPlantsSuccess([]))
  }
}

function* getPlanningGroupsRequest(action) {
  try {
    const response = yield httpGet('options/planningGroups')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPlanningGroupsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPlanningGroupsSuccess([]))
  }
}

function* getPrCategoriesRequest(action) {
  try {
    const response = yield httpGet('options/prCategories')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPrCategoriesSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPrCategoriesSuccess([]))
  }
}

function* getProfitCentersRequest(action) {
  try {
    const response = yield httpGet('options/profitCenters')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getProfitCentersSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getProfitCentersSuccess([]))
  }
}

function* getPrTypesRequest(action) {
  try {
    const response = yield httpGet('options/prTypes')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPrTypesSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPrTypesSuccess([]))
  }
}

function* getPurchasingGroupsRequest(action) {
  try {
    const response = yield httpGet('options/purchasingGroups')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPurchasingGroupsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPurchasingGroupsSuccess([]))
  }
}

function* getPurchasingOrgsRequest(action) {
  try {
    const response = yield httpGet('options/purchasingOrgs')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPurchasingOrgsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPurchasingOrgsSuccess([]))
  }
}

function* getReconciliationsRequest(action) {
  const { companyCode } = action.payload
  try {
    const response = yield httpGet(`options/reconciliationAccount/${companyCode}`)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getReconciliationsSuccess(response.data, companyCode))
      }
    }
  } catch (e) {
    yield put(getReconciliationsSuccess([]))
  }
}

function* getSortKeysRequest(action) {
  try {
    const response = yield httpGet('options/sortKeys')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getSortKeysSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getSortKeysSuccess([]))
  }
}

function* getStorageLocationsRequest(action) {
  try {
    const response = yield httpGet('options/storageLocations')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getStorageLocationsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getStorageLocationsSuccess([]))
  }
}

function* getTradingPartnersRequest(action) {
  try {
    const response = yield httpGet('options/tradingPartners')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getTradingPartnersSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getTradingPartnersSuccess([]))
  }
}

function* getUnitsRequest(action) {
  try {
    const response = yield httpGet('options/units')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getUnitsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getUnitsSuccess([]))
  }
}

function* getVendorsRequest(action) {
  try {
    const state = yield select()
    if (!state.options.vendors.data.length&&state.options.vendors.timeStamp==1) {
      const response = yield httpGet('options/vendors')
      if (response.status >= 200 && response.status < 300) {
        if (response.data) {
          yield put(getVendorsSuccess(response.data))
        }
      }
    }
  } catch (e) {
    yield put(getVendorsSuccess([]))
  }
}

function* getWbsElementsRequest(action) {
  const { companyCode } = action.payload
  try {
    const response = yield httpGet('options/wbsElements', { companyCode })
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWbsElementsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getWbsElementsSuccess([]))
  }
}

function* getWhtTypesRequest(action) {
  try {
    const response = yield httpGet('options/withholdingTaxTypes')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWhtTypesSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getWhtTypesSuccess([]))
  }
}

function* getWhtReceiptTypesRequest(action) {
  try {
    const response = yield httpGet('options/withholdingTaxReceiptTypes')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWhtReceiptTypesSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getWhtReceiptTypesSuccess([]))
  }
}

function* fetchProjectsRequest(action) {
  const { companyCode } = action.payload
  try {
    let response = null
    if(companyCode){
      response = yield httpGet(`goas/default/projects?companyCode=${companyCode}`)
    }else{
      response = yield httpGet('goas/projects')
    }
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchProjectsSuccess(response.data.map((item,i)=>{
          return {key:i, value:item.id,text:item.projectOfficialName}
        })))
      }
    }
  } catch (e) {
  }
}

function* fetchPMUsersRequest() {
  try {
    const response = yield httpGet('options/SearchPM')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchPMUsersSuccess(response.data.map((item,i)=>({key:`pm${i}`,value:item.username,text:item.fullname}))))
      }
    }
  } catch (e) {
  }
}

function* fetchRolePurchaseOfficerRequest(action) {
  const { purchGroup } = action.payload
  try {
    const response = yield httpGet('members/roleOfficerPurchaseUsers/'+purchGroup)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchRolePurchaseOfficerSuccess(response.data))
      }
    }
  } catch (e) {
  }
}

function* fetchPOActiveVendorsRequest() {
  try {
    const response = yield httpGet('purchaseOrders/getActiveVendors/')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchPOActiveVendorsSuccess(response.data))
      }
    }
  } catch (e) {
  }
}

function* fetchContractActiveVendorsRequest() {
  try {
    const response = yield httpGet('contracts/getActiveVendors/')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchContractActiveVendorsSuccess(response.data))
      }
    }
  }catch (e) {
  }
}

function* fetchProductBrandsOptionsRequest() {
  try {
    const response = yield httpGet('products/brands')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchProductBrandsOptionsSuccess(response.data.map((item,i)=>{
          return {key:i, value:item.brandCode, text:item.name}
        })))
      }
    }
  } catch (e) {
  }
}

function* getTypeOfTendersRequest(action) {
  try {
    const response = yield httpGet('options/typeOfTenders')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getTypeOfTendersSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getTypeOfTendersSuccess([]))
  }
}

function* getWorksRequest(action) {
  try {
    const response = yield httpGet('options/works')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getWorksSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getWorksSuccess([]))
  }
}

function* fetchStatusPOWorkSpaceRequest() {
  try {
    const response = yield httpGet('options/statusActivity/PurchaseOrder')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(fetchStatusPOWorkSpaceSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(fetchStatusPOWorkSpaceSuccess([]))
  }
}

function* getStampDutyOptionsRequest(action) {
  try {
    const response = yield httpGet('options/stampDutyType')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getStampDutyOptionsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getStampDutyOptionsSuccess([]))
  }
}

function* getPrSpecialOptionsRequest(action) {
  const { type } = action.payload
  try {
    const response = yield httpGet('options/prSpecial',{type:type||""})
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getPrSpecialOptionsSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getPrSpecialOptionsSuccess([]))
  }
}

function* getPoNumberRequest(action) {
  const { companyCode, onLoadSuccess } = action.payload
  try {
    const response = yield httpGet(`options/poNumber/${companyCode}`)
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        if (onLoadSuccess) {
          onLoadSuccess()
        }
        yield put(getPoNumberSuccess(response.data, companyCode))
      }
    }
  } catch (e) {
    if (onLoadSuccess) {
      onLoadSuccess()
    }
    yield put(getPoNumberSuccess([], ''))
  }
}

function* getListPoCompleteNumberRequest(action) {
  try {
    const response = yield httpGet('options/list/purchaseOrderComplete')
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getListPoCompleteNumberSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(getListPoCompleteNumberSuccess([]))
  }
}

export function* watchOptionsSaga() {
  yield takeLatest(GET_ACCOUNT_ASSIGNMENTS.REQUEST, getAccountAssignmentsRequest)
  yield takeLatest(GET_ASSETS.REQUEST, getAssetsRequest)
  yield takeEvery(GET_BANK_BRANCH.REQUEST, getBankBranchRequest)
  yield takeLatest(GET_BANK_KEYS.REQUEST, getBankKeysRequest)
  yield takeLatest(GET_BUDGET_TYPES.REQUEST, getBudgetTypesRequest)
  yield takeLatest(GET_BUSINESS_PARTNERS.REQUEST, getBusinessPartnersRequest)
  yield takeLatest(GET_BP_GROUPS.REQUEST, getBPGroupsRequest)
  yield takeLeading(GET_COMPANIES.REQUEST, getCompaniesRequest)
  // yield takeLatest(GET_PAYEES.REQUEST, getPayeesRequest)
  yield takeLatest(GET_COST_CENTER.REQUEST, getCostCenterRequest)
  yield takeLatest(GET_COUNTRY.REQUEST, getCountryRequest)
  yield takeLatest(GET_CURRENCIES.REQUEST, getCurrenciesRequest)
  yield takeLatest(GET_CUSTOMERS.REQUEST, getCustomersRequest)
  yield takeLatest(GET_GL_ACCOUNTS.REQUEST, getGlAccountsRequest)
  yield takeLatest(GET_INCOTERMS.REQUEST, getIncotermsRequest)
  yield takeLatest(GET_INDUSTRIES.REQUEST, getIndustriesRequest)
  yield takeLatest(GET_MATERIAL_GROUPS.REQUEST, getMaterialGroupsRequest)
  yield takeEvery(GET_MATERIALS.REQUEST, getMaterialsRequest)
  yield takeLatest(GET_ORDERS.REQUEST, getOrdersRequest)
  yield takeLatest(GET_PAYMENT_BLOCK.REQUEST, getPaymentBlocksRequest)
  yield takeLatest(GET_PAYMENT_METHOD.REQUEST, getPaymentMethodsRequest)
  yield takeLatest(GET_PAYMENT_TERM.REQUEST, getPaymentTermsRequest)
  yield takeLatest(GET_PLANTS.REQUEST, getPlantsRequest)
  yield takeLatest(GET_PLANNING_GROUPS.REQUEST, getPlanningGroupsRequest)
  yield takeLatest(GET_PR_CATEGORIES.REQUEST, getPrCategoriesRequest)
  yield takeLatest(GET_PR_TYPES.REQUEST, getPrTypesRequest)
  yield takeLatest(GET_PROFIT_CENTERS.REQUEST, getProfitCentersRequest)
  yield takeLatest(GET_PURCHASING_GROUPS.REQUEST, getPurchasingGroupsRequest)
  yield takeLatest(GET_PURCHASING_ORGS.REQUEST, getPurchasingOrgsRequest)
  yield takeLatest(GET_RECONCILIATIONS.REQUEST, getReconciliationsRequest)
  yield takeLatest(GET_SORT_KEYS.REQUEST, getSortKeysRequest)
  yield takeLatest(GET_STORAGE_LOCATIONS.REQUEST, getStorageLocationsRequest)
  yield takeLatest(GET_TRADING_PARTNERS.REQUEST, getTradingPartnersRequest)
  yield takeLatest(GET_UNITS.REQUEST, getUnitsRequest)
  yield takeLeading(GET_VENDORS.REQUEST, getVendorsRequest)
  yield takeLatest(GET_WBS_ELEMENTS.REQUEST, getWbsElementsRequest)
  yield takeLatest(GET_WHT_TYPES.REQUEST, getWhtTypesRequest)
  yield takeLatest(GET_WHT_RECEIPT_TYPES.REQUEST, getWhtReceiptTypesRequest)
  yield takeLatest(FETCH_PROJECTS.REQUEST, fetchProjectsRequest)
  yield takeLatest(FETCH_PM_USERS.REQUEST, fetchPMUsersRequest)
  yield takeLatest(FETCH_ROLE_PURCHASE_OFFICER.REQUEST, fetchRolePurchaseOfficerRequest)
  yield takeLatest(FETCH_PO_ACTIVE_VENDOR.REQUEST, fetchPOActiveVendorsRequest)
  yield takeLatest(FETCH_CONTRACT_ACTIVE_VENDOR.REQUEST, fetchContractActiveVendorsRequest)
  yield takeLatest(FETCH_PRODUCT_BRANDS_OPTIONS.REQUEST, fetchProductBrandsOptionsRequest)
  yield takeLatest(GET_TYPE_OF_TENDERS.REQUEST, getTypeOfTendersRequest)
  yield takeLatest(GET_WORKS.REQUEST, getWorksRequest)
  yield takeLatest(FETCH_STATS_PO_WORKSPACE.REQUEST, fetchStatusPOWorkSpaceRequest)
  yield takeLatest(GET_STAMP_DUTY_OPTIONS.REQUEST, getStampDutyOptionsRequest)
  yield takeLatest(GET_PR_SPECIAL_OPTIONS.REQUEST, getPrSpecialOptionsRequest)
  yield takeLatest(GET_PO_NUMBER.REQUEST, getPoNumberRequest)
  yield takeLatest(GET_LIST_PO_COMPLETE_NUMBER.REQUEST, getListPoCompleteNumberRequest)
}

export default createReducer(initial, state => ({
  [GET_ACCOUNT_ASSIGNMENTS.REQUEST]: () => ({
    ...state,
    accountAssignments: { data: [], loading: true },
  }),
  [GET_ACCOUNT_ASSIGNMENTS.SUCCESS]: (data) => ({
    ...state,
    accountAssignments: { data: data.data, loading: false },
  }),
  [GET_ASSETS.REQUEST]: () => ({
    ...state,
    assets: { data: [], loading: true }
  }),
  [GET_ASSETS.SUCCESS]: (data) => ({
    ...state,
    assets: { data: data.data, loading: false }
  }),
  [GET_BANK_BRANCH.REQUEST]: (data) => ({
    ...state,
    bankBranch: { 
      data: {
        ...state.bankBranch.data,
        [data.bankKey]: [] 
      }, 
      loading: true 
    }
  }),
  [GET_BANK_BRANCH.SUCCESS]: (data) => ({
    ...state,
    bankBranch: { 
      data: { 
        ...state.bankBranch.data, 
        [data.bankKey]: data.data 
      }, 
      loading: false 
    },
  }),
  [GET_BANK_KEYS.REQUEST]: () => ({
    ...state,
    bankKeys: { data: [], loading: true }
  }),
  [GET_BANK_KEYS.SUCCESS]: (data) => ({
    ...state,
    bankKeys: { data: data.data, loading: false },
  }),
  [GET_BUDGET_TYPES.REQUEST]: () => ({
    ...state,
    budgetTypes: { data: [], loading: true }
  }),
  [GET_BUDGET_TYPES.SUCCESS]: (data) => ({
    ...state,
    budgetTypes: { data: data.data, loading: false },
  }),
  [GET_BUSINESS_PARTNERS.REQUEST]: () => ({
    ...state,
    businessPartners: { data: [], loading: true }
  }),
  [GET_BUSINESS_PARTNERS.SUCCESS]: (data) => ({
    ...state,
    businessPartners: { data: data.data, loading: false },
  }),
  [GET_BP_GROUPS.REQUEST]: () => ({
    ...state,
    businessPartnerGroups: { data: [], loading: true }
  }),
  [GET_BP_GROUPS.SUCCESS]: (data) => ({
    ...state,
    businessPartnerGroups: { data: data.data, loading: false },
  }),
  [GET_COMPANIES.REQUEST]: () => ({
    ...state,
    companies: { data: state.companies.data, loading: state.companies.data.length==0, timeStamp: state.companies.timeStamp+1 }
  }),
  [GET_COMPANIES.SUCCESS]: (data) => ({
    ...state,
    companies: { data: data.data, loading: false, timeStamp:0 }
  }),
  [GET_COST_CENTER.REQUEST]: () => ({
    ...state,
    costCenters: { data: [], loading: true },
  }),
  [GET_COST_CENTER.SUCCESS]: (data) => ({
    ...state,
    costCenters: { data: data.data, loading: false },
  }),
  [GET_COUNTRY.REQUEST]: () => ({
    ...state,
    countries: { data: [], loading: true },
  }),
  [GET_COUNTRY.SUCCESS]: (data) => ({
    ...state,
    countries: { data: data.data, loading: false },
  }),
  [GET_CURRENCIES.REQUEST]: () => ({
    ...state,
    currencies: { data: [], loading: true }
  }),
  [GET_CURRENCIES.SUCCESS]: (data) => ({
    ...state,
    currencies: { data: data.data, loading: false },
  }),
  [GET_CUSTOMERS.REQUEST]: () => ({
    ...state,
    customers: { data: [], loading: true }
  }),
  [GET_CUSTOMERS.SUCCESS]: (data) => ({
    ...state,
    customers: { data: data.data, loading: false },
  }),
  [GET_GL_ACCOUNTS.REQUEST]: () => ({
    ...state,
    glAccounts: { data: [], loading: true }
  }),
  [GET_GL_ACCOUNTS.SUCCESS]: (data) => ({
    ...state,
    glAccounts: { data: data.data, loading: false },
  }),
  [GET_INCOTERMS.REQUEST]: () => ({
    ...state,
    incoterms: { data: [], loading: true }
  }),
  [GET_INCOTERMS.SUCCESS]: (data) => ({
    ...state,
    incoterms: { data: data.data, loading: false },
  }),
  [GET_INDUSTRIES.REQUEST]: () => ({
    ...state,
    industries: { data: [], loading: true }
  }),
  [GET_INDUSTRIES.SUCCESS]: (data) => ({
    ...state,
    industries: { data: data.data, loading: false },
  }),
  [GET_MATERIAL_GROUPS.REQUEST]: () => ({
    ...state,
    materialGroups: { data: [], loading: true },
  }),
  [GET_MATERIAL_GROUPS.SUCCESS]: (data) => ({
    ...state,
    materialGroups: { data: data.data, loading: false },
  }),
  [GET_MATERIALS.REQUEST]: () => ({
    ...state,
    materials: { data: {}, loading: true },
  }),
  [GET_MATERIALS.SUCCESS]: (data) => ({
    ...state,
    materials: {
      data: {
        ...state.materials.data,
        [data.plant]: data.data
      },
      loading: false
    },
  }),
  [GET_ORDERS.REQUEST]: () => ({
    ...state,
    orders: { data: [], loading: true }
  }),
  [GET_ORDERS.SUCCESS]: (data) => ({
    ...state,
    orders: { data: data.data, loading: false }
  }),
  [GET_PAYMENT_BLOCK.REQUEST]: () => ({
    ...state,
    paymentBlocks: { data: [], loading: true }
  }),
  [GET_PAYMENT_BLOCK.SUCCESS]: (data) => ({
    ...state,
    paymentBlocks: { data: data.data, loading: false }
  }),
  [GET_PAYMENT_METHOD.REQUEST]: () => ({
    ...state,
    paymentMethods: { data: [], loading: true }
  }),
  [GET_PAYMENT_METHOD.SUCCESS]: (data) => ({
    ...state,
    paymentMethods: { data: data.data, loading: false }
  }),
  [GET_PAYMENT_TERM.REQUEST]: () => ({
    ...state,
    paymentTerms: { data: [], loading: true }
  }),
  [GET_PAYMENT_TERM.SUCCESS]: (data) => ({
    ...state,
    paymentTerms: { data: data.data, loading: false }
  }),
  [GET_PLANTS.REQUEST]: () => ({
    ...state,
    plants: { data: [], loading: true }
  }),
  [GET_PLANTS.SUCCESS]: (data) => ({
    ...state,
    plants: { data: data.data, loading: false }
  }),
  [GET_PLANNING_GROUPS.REQUEST]: () => ({
    ...state,
    planningGroups: { data: [], loading: true }
  }),
  [GET_PLANNING_GROUPS.SUCCESS]: (data) => ({
    ...state,
    planningGroups: { data: data.data, loading: false }
  }),
  [GET_PR_CATEGORIES.REQUEST]: () => ({
    ...state,
    prCategories: { data: [], loading: true }
  }),
  [GET_PR_CATEGORIES.SUCCESS]: (data) => ({
    ...state,
    prCategories: { data: data.data, loading: false },
  }),
  [GET_PR_TYPES.REQUEST]: () => ({
    ...state,
    prTypes: { data: [], loading: true }
  }),
  [GET_PR_TYPES.SUCCESS]: (data) => ({
    ...state,
    prTypes: { data: data.data, loading: false },
  }),
  [GET_PROFIT_CENTERS.REQUEST]: () => ({
    ...state,
    profitCenters: { data: [], loading: true }
  }),
  [GET_PROFIT_CENTERS.SUCCESS]: (data) => ({
    ...state,
    profitCenters: { data: data.data, loading: false }
  }),
  [GET_PURCHASING_GROUPS.REQUEST]: () => ({
    ...state,
    purchasingGroups: { data: [], loading: true }
  }),
  [GET_PURCHASING_GROUPS.SUCCESS]: (data) => ({
    ...state,
    purchasingGroups: { data: data.data, loading: false }
  }),
  [GET_PURCHASING_ORGS.REQUEST]: () => ({
    ...state,
    purchasingOrgs: { data: [], loading: true }
  }),
  [GET_PURCHASING_ORGS.SUCCESS]: (data) => ({
    ...state,
    purchasingOrgs: { data: data.data, loading: false },
  }),
  [GET_RECONCILIATIONS.REQUEST]: (data) => ({
    ...state,
    reconciliations: { data: [], companyCode: data.companyCode, loading: true }
  }),
  [GET_RECONCILIATIONS.SUCCESS]: (data) => ({
    ...state,
    reconciliations: { data: data.data, companyCode: data.companyCode, loading: false },
  }),
  [GET_SORT_KEYS.REQUEST]: () => ({
    ...state,
    sortKeys: { data: [], loading: true },
  }),
  [GET_SORT_KEYS.SUCCESS]: (data) => ({
    ...state,
    sortKeys: { data: data.data, loading: false },
  }),
  [GET_STORAGE_LOCATIONS.REQUEST]: () => ({
    ...state,
    storageLocations: { data: [], loading: true },
  }),
  [GET_STORAGE_LOCATIONS.SUCCESS]: (data) => ({
    ...state,
    storageLocations: { data: data.data, loading: false },
  }),
  [GET_TRADING_PARTNERS.REQUEST]: () => ({
    ...state,
    tradingPartners: { data: [], loading: true },
  }),
  [GET_TRADING_PARTNERS.SUCCESS]: (data) => ({
    ...state,
    tradingPartners: { data: data.data, loading: false },
  }),
  [GET_UNITS.REQUEST]: () => ({
    ...state,
    units: { data: [], loading: true }
  }),
  [GET_UNITS.SUCCESS]: (data) => ({
    ...state,
    units: { data: data.data, loading: false }
  }),
  [GET_VENDORS.REQUEST]: () => ({
    ...state,
    vendors: { data: state.vendors.data, loading: state.vendors.data.length==0, timeStamp: state.vendors.timeStamp+1}
  }),
  [GET_VENDORS.SUCCESS]: (data) => ({
    ...state,
    vendors: { data: data.data, loading: false, timeStamp: 0 }
  }),
  [GET_WBS_ELEMENTS.REQUEST]: () => ({
    ...state,
    wbsElements: { data: [], loading: true },
  }),
  [GET_WBS_ELEMENTS.SUCCESS]: (data) => ({
    ...state,
    wbsElements: { data: data.data, loading: false },
  }),
  [GET_WHT_TYPES.REQUEST]: () => ({
    ...state,
    whtTypes: { data: [], loading: true },
  }),
  [GET_WHT_TYPES.SUCCESS]: (data) => ({
    ...state,
    whtTypes: { data: data.data, loading: false },
  }),
  [GET_WHT_RECEIPT_TYPES.REQUEST]: () => ({
    ...state,
    whtReceiptTypes: { data: [], loading: true },
  }),
  [GET_WHT_RECEIPT_TYPES.SUCCESS]: (data) => ({
    ...state,
    whtReceiptTypes: { data: data.data, loading: false },
  }),
  [FETCH_PROJECTS.REQUEST]: () => ({
    ...state,
    projects: { data: [], loading: true }
  }),
  [FETCH_PROJECTS.SUCCESS]: (data) => ({
    ...state,
    projects: { data: data.data, loading: false },
  }),
  [FETCH_PM_USERS.REQUEST]: () => ({
    ...state,
    pmUsers: { data: [], loading: true }
  }),
  [FETCH_PM_USERS.SUCCESS]: (data) => ({
    ...state,
    pmUsers: { data: data.data, loading: false },
  }),
  [FETCH_ROLE_PURCHASE_OFFICER.REQUEST]: () => ({
    ...state,
    purchaseOfficer: { data: [], loading: true }
  }),
  [FETCH_ROLE_PURCHASE_OFFICER.SUCCESS]: (data) => ({
    ...state,
    purchaseOfficer: { data: data.data, loading: false },
  }),
  [FETCH_PO_ACTIVE_VENDOR.REQUEST]: () => ({
    ...state,
    poVendors: { data: [], loading: true }
  }),
  [FETCH_PO_ACTIVE_VENDOR.SUCCESS]: (data) => ({
    ...state,
    poVendors: { data: data.data, loading: false },
  }),
  [FETCH_CONTRACT_ACTIVE_VENDOR.REQUEST]: () => ({
    ...state,
    contractVendors: { data: [], loading: true }
  }),
  [FETCH_CONTRACT_ACTIVE_VENDOR.SUCCESS]: (data) => ({
    ...state,
    contractVendors: { data: data.data, loading: false },
  }),
  [FETCH_PRODUCT_BRANDS_OPTIONS.REQUEST]: () => ({
    ...state,
    productBrands: { data: [], loading: true }
  }),
  [FETCH_PRODUCT_BRANDS_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    productBrands: { data: data.data, loading: false },
  }),
  [GET_TYPE_OF_TENDERS.REQUEST]: () => ({
    ...state,
    typeOfTenders: { data: [], loading: true },
  }),
  [GET_TYPE_OF_TENDERS.SUCCESS]: (data) => ({
    ...state,
    typeOfTenders: { data: data.data, loading: false },
  }),
  [GET_WORKS.REQUEST]: () => ({
    ...state,
    works: { data: [], loading: true },
  }),
  [GET_WORKS.SUCCESS]: (data) => ({
    ...state,
    works: { data: data.data, loading: false },
  }),
  [FETCH_STATS_PO_WORKSPACE.REQUEST]: () => ({
    ...state,
    statusPOWorkSpace: { data: [], loading: true },
  }),
  [FETCH_STATS_PO_WORKSPACE.SUCCESS]: (data) => ({
    ...state,
    statusPOWorkSpace: { data: data.data, loading: false },
  }),
  [GET_STAMP_DUTY_OPTIONS.REQUEST]: () => ({
    ...state,
    stampDuty: { data: [], loading: true },
  }),
  [GET_STAMP_DUTY_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    stampDuty: { data: data.data, loading: false },
  }),
  [GET_PR_SPECIAL_OPTIONS.REQUEST]: () => ({
    ...state,
    prSpecial: { data: [], loading: true },
  }),
  [GET_PR_SPECIAL_OPTIONS.SUCCESS]: (data) => ({
    ...state,
    prSpecial: { data: data.data, loading: false },
  }),
  [GET_PO_NUMBER.REQUEST]: (data) => ({
    ...state,
    poNumbers: { data: [], loading: true, companyCode: data.companyCode },
  }),
  [GET_PO_NUMBER.SUCCESS]: (data) => ({
    ...state,
    poNumbers: { data: data.data, loading: false, companyCode: data.companyCode },
  }),
  [GET_LIST_PO_COMPLETE_NUMBER.REQUEST]: (data) => ({
    ...state,
    optionPoComplete: { data: [], loading: true },
  }),
  [GET_LIST_PO_COMPLETE_NUMBER.SUCCESS]: (data) => ({
    ...state,
    optionPoComplete: { data: data.data, loading: false },
  }),
}))